import { MyTableComponent, Input } from "components"
import { useState, useEffect } from "react"
import { Box } from "theme-ui"
import tittle from "./Tittle.png"
import { useFetchPtDataQuery } from "../../store/Features/processData/ptData-api-slice"
import { IOepnvDataElement } from "@types"
import { useTranslation } from "react-i18next"

export const PtData = () => {
     // language translator
  const { t } = useTranslation("translation")
 const { data } = useFetchPtDataQuery()
 const [selectedData, setSelectedData] = useState<IOepnvDataElement[]>([])
 const [allData, setAllData] = useState<IOepnvDataElement[]>([])

 const columns = [
  { Header: t("headquarters"), accessor: "creation_time" },
  { Header: t("Attachment"), accessor: "call_point_number" },
  { Header: t("Connection"), accessor: "line_number" },
  { Header: t("Connection"), accessor: "course_number" },
  { Header: t("until"), accessor: "route_number" },
 ]

 useEffect(() => {
  const dataElements: IOepnvDataElement[] = []
  if (data) {
   data.map((single) => {
    return single.oepnv_data_elements.map((data) => dataElements.push(data))
   })
   setSelectedData(dataElements)
   setAllData(dataElements)
  }
  // eslint-disable-next-line
 }, [data])

 const searchHandler = (keyword: string) => {
  if (keyword !== "") {
   const filterData: any = allData?.filter(
    (item) => item?.creation_time?.toLowerCase()?.indexOf(keyword.toLowerCase()) !== -1,
   )
   setSelectedData([...filterData])
  } else {
   setSelectedData(allData)
  }
 }
 return (
  <div className="w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full">
   <div className=" py-4 ">
    <h1 className="font-semibold text-2xl Jakarta-font">{t("publicTransportData")}</h1>
   </div>
   <Box bg="highlight" color="text-black">
    <div className="py-3 px-3 flex justify-between items-center">
     <h1 className="Jakarta-font font-semibold">{t("publicTransportData")}</h1>

     <div className="flex items-center justify-end">
      <p className="Jakarta-font">{t("category")}:</p>

      <div className="bg-white h-8 w-12  mx-4  border-light-gray border-[1.5px] rounded flex justify-center items-center">
       <img className="w-4" src={tittle} alt="tittlesign" />
      </div>

      {/* ======== SearchHandler  ======== */}
      <div className="w-1/4 hover:w-[45%] transition-all delay-150 duration-700">
       <Input
        onChange={searchHandler}
        className="outline-none text-black border-light-gray border-[1.5px] h-8 rounded  pl-2    "
        placeholder={t("search")}
        type="search"
       />
      </div>
     </div>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent
    fullHeight={false}
    columns={columns}
    data={data ? selectedData : []}
    paginate={true}
   />
  </div>
 )
}
